import React from 'react';
import { Link } from '@/components/LocalizedLink';

const linkClass = (active, base) =>
  `${base} text-sm font-sans font-medium rounded-md transition-colors ${active ? 'text-saffron bg-saffron/5' : 'text-earth/60 hover:text-earth-dark hover:bg-saffron/5'}`;

export function DesktopNav({ links, activePath, lang, onToggleLang, quoteLabel }) {
  return (
    <div className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
      {links.map(link => (
        <Link key={link.to} to={link.to} className={linkClass(activePath === link.to, 'px-3 py-2')}>
          {link.label}
        </Link>
      ))}
      <button
        onClick={onToggleLang}
        className="ml-1 px-2.5 py-2 text-xs font-sans font-bold rounded-md border border-earth/15 text-earth/70 hover:bg-saffron/5 hover:text-saffron transition-colors"
        data-testid="lang-toggle"
        title={lang === 'en' ? 'हिंदी में देखें' : 'View in English'}
      >
        {lang === 'en' ? 'हि' : 'EN'}
      </button>
      <Link to="/contact" className="ml-2 bg-saffron text-white font-sans font-semibold text-sm px-5 py-2.5 rounded-md hover:bg-saffron-dark transition-colors shadow-saffron-glow" data-testid="nav-get-quote">
        {quoteLabel}
      </Link>
    </div>
  );
}

export function MobileNav({ links, activePath, lang, onToggleLang, quoteLabel }) {
  return (
    <div className="lg:hidden bg-white border-t border-saffron-100 shadow-lg" data-testid="mobile-nav">
      <div className="px-4 py-4 space-y-1">
        {links.map(link => (
          <Link key={link.to} to={link.to} className={linkClass(activePath === link.to, 'block px-4 py-3')}>
            {link.label}
          </Link>
        ))}
        <div className="flex items-center gap-2 mt-2">
          <button onClick={onToggleLang} className="px-3 py-3 text-xs font-sans font-bold rounded-md border border-earth/15 text-earth/70" data-testid="lang-toggle-mobile">
            {lang === 'en' ? 'हिंदी' : 'English'}
          </button>
          <Link to="/contact" className="flex-1 bg-saffron text-white text-center font-sans font-semibold text-sm px-5 py-3 rounded-md" data-testid="mobile-nav-get-quote">
            {quoteLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}
